import React from 'react';
import Swal from 'sweetalert2';
import Picker from 'emoji-picker-react';
import { Link } from 'react-router-dom';
import { Form, Field } from 'react-final-form';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import FormLayout from '../../components/forms/FormLayout';
import LayoutSmall from '../../components/layout/LayoutSmall';
import TextWithIconButtonInput from '../../components/forms/TextWithIconButtonInput';
import AttachImage from '../../components/forms/AttachImage';
import Loader from '../../components/commons/Loader';
import UserMessageHeader from '../../components/customs/UserMessageHeader';
import PrescriptionElement from '../../components/customs/PrescriptionElement';
import AutoQuery from '../../components/commons/AutoQuery';

import { uuidv4 } from '../../libraries/utils';
import Icon from '../../libraries/icons';
import { ToastContainer, notify } from '../../libraries/notifications';

import purchasesActions from '../../context/purchases/actions';
import internalsActions from '../../context/internals/actions';
import messagesActions from '../../context/messages/actions';
import filesActions from '../../context/files/actions'

import config from '../../config';
import { history } from '../../routes';

const customSwal = Swal.mixin({
  customClass: {
    confirmButton: 'btn btn-primary mx-1',
    cancelButton: 'btn btn-outline btn-primary mx-1',
    denyButton: 'btn btn-primary mx-1',
    title: 'swal2-title',
    htmlContainer: 'swal-text',
  },
  buttonsStyling: false,
  background: '#fff',
});

const alignment = (message, owner) => {
  return message.source.id === owner || message.source === owner ? 'chat-end' : 'chat-start'
}
const style = (message, owner, chat, i) => {
  const prevMessage = chat[i - 1]
  const isPrevMessageDefined = prevMessage !== undefined
  return (message.source.id === owner || message.source === owner ? `bg-gray-200 ml-2 md:ml-8 text-black` : `text-white bg-primary mr-2 md:mr-8`) + `${message.json_data?.deleted_for_all ? ' italic' : ' '}`
}

const seen = (seenIndex, chat, owner, i) => {
  return seenIndex === i && (i === chat.length - 1 || chat[i + 1].source.id === owner || chat[i + 1].source === owner)
}
const findLastSeen = (chat, owner) => {
  chat = chat.map(message => message.target.id !== owner ? message.readed : 0)
  return chat.lastIndexOf(1)
}
const focusInput = () => {
  Array.from(document.getElementsByName('body'))[0].focus()
}

class ChatClass extends React.Component {
  constructor(props) {
    super(props);
    this.t = this.props.t;
    this.state = {
      pickerOpen: false,
      loadingMessages: true,
      seenIndex: null,
      chat: [],
      root: null,
      chatWith: null,
      loading: true,
      preview: null,
      image_loading: true,
      root_id: null,
      deleteMode: false,
      previewImage: null,
      transaction: null,
    }
  }

  componentDidMount() {

  }


  isOwner = (source) => {
    return source?.id === this.props.user.id
  }

  scrollToBottom = () => {
    const chatHTML = document.getElementById('chat');
    chatHTML?.scrollTo(0, chatHTML.scrollHeight);
  }

  getChat = async () => {
    const root_id = this.props?.match?.params?.root_id
    if (root_id) {
      this.setState({ loadingMessages: true, root_id })
      let params = {}
      params.where = {
        custom: {
          id: root_id,
          comparison: 'OR',
          parent: root_id
        }
      }
      await this.props.onGetAllMessages(params);
      const { items, error } = this.props.messages;
      if (error) {
        notify(this.t(error.message));
      } else {
        const root = items.find(e => e.parent === "root")
        const { transaction } = this.state;
        if (!root) {
          history.push(config.ROUTES.MESSAGES);
          return
        }
        if (items.length > 0 && !transaction) {
          await this.getPurchase(items)
        }
        let owner = this.props.auth.user.id
        const chat = items.filter(e => e.source.id === owner || e.source === owner ? !e.json_data['deleted_for_source'] : !e.json_data['deleted_for_target'])
        const isOwner = await this.isOwner(root?.source);
        const chatWith = isOwner ? root.target : root.source
        const image_loading = false
        if (root.json_data[`unread_messages_for_${isOwner ? 'source' : 'target'}`] > 0) {
          await this.markAsReaded(root, isOwner);
        }
        this.setState({ chat, root, chatWith, image_loading, owner }, () => { this.scrollToBottom(); });
      }
      this.setState({ loading: false, loadingMessages: false })
    }
  }

  getPurchase = async (items) => {
    console.log("____get_purchases", items[0].related_to);
    await this.props.onGetPurchase(items[0].related_to);
    const { transaction } = this.props;
    if (transaction.error) {
      notify(this.t(transaction.error.message));
    }
    else {
      this.setState({ transaction: transaction.item });
    }
  }

  markAsReaded = async (root, isOwner) => {
    const obj = {
      id: root.id,
      json_data: {
        ...root.json_data, [`unread_messages_for_${isOwner ? 'source' : 'target'}`]: 0
      }
    }
    await this.props.onSendMessage(obj);
    const { message } = this.props;
    if (message.error) {
      notify(this.t(message.error.message));
    }
  }

  validateForm = (values) => {
    return values.body && true
  }

  onSubmit = async (values, form) => {
    const { root, owner, chatWith, chat } = this.state;
    let chat_ = [...this.state.chat]
    let chat_last_message = chat_.length - 1
    if (this.validateForm(values)) {
      // create an object
      const message_ = {
        ...values,
        parent: root.id,
        subject: root.subject,
        source: owner,
        target: chatWith.id,
        type: 'message',
        loading: true,
        related_to: root?.related_to || null,
        json_data: {
          _id: uuidv4(),
        },
      }
      this.setState({ chat: [...chat, message_] })

      await this.props.onSendMessage(message_);
      const { message } = this.props;
      if (message.error) {
        notify(this.t(message.error.message));
      } else {
        if (message.item.parent === 'root') {
          const data = message.item ? { ...message.item, source: { id: message.item.source }, target: { id: message.item.target } } : this.state.chat.find(e => e.parent === 'root')
          this.setState({ root: data })
        } else {
          this.setState({
            chat: this.state.chat
              .map(e => (e?.json_data?._id === message.item?.json_data?._id || e.id === message.item.id) ? { ...message.item, source: { id: message.item.source }, target: { id: message.item.target }, json_data: { ...message.item.json_data, picture: e?.json_data?.picture } } : e)
              .filter(e => e.source.id === owner || e.source === owner ? !e.json_data.deleted_for_source : !e.json_data.deleted_for_target)
          }, () => { this.scrollToBottom(); });
          // ** It also modify the root element of the chat, to notify a new message on the inbox/sent tray of the other part
          if (root.source.id) {
            const unreadMessages = chat.map(message => message.target.id !== owner ? message.readed : 1).filter(e => !e).length
            if (unreadMessages > 0) {
              const obj = { id: root.id, json_data: { ...root.json_data, [`unread_messages_for_${await this.isOwner(root?.source) ? 'target' : 'source'}`]: unreadMessages } }
              await this.props.onSendMessage(obj);
            }
          }
        }
      }

      // let last_m = chat_[chat_last_message]
      chat_[chat_last_message].json_data.answered = 1
      // const obj = {
      //   id: last_m.id,
      //   json_data: {
      //     last_message_portion: values.body,
      //     answered: 1,
      //   }
      // }
      //      await this.props.onSendMessage(obj);
      //      const { message: patchedMessage } = this.props;
      //      if (patchedMessage.error) {
      //        notify(this.t(patchedMessage.error.message));
      //      }
      form.reset()
    }
  }

  previewImage = ({ data, e }) => {
    this.setState({ preview: { data, src: URL.createObjectURL(e) } });
  }

  uploadImage = async (values, form) => {
    const { root, owner, chatWith, chat, preview, transaction } = this.state;
    const { data, src } = preview;
    const code = parseInt(Math.random() * 10 ** 9)
    let image_identifier = `message_input_${code}`
    data.append('identifier', image_identifier);
    const message_ = {
      body: values?.body || null,
      parent: root.id,
      subject: root.subject,
      source: owner,
      target: chatWith.id,
      type: 'message',
      loading: true,
      related_to: root?.related_to || null,
      json_data: {
        picture: src,
        _id: code,
        deleted_for_source: 0
      }
    }
    this.setState({ chat: [...chat, message_], preview: null })
    await this.props.onPictureUpload(data);
    const { files, error } = this.props.files;
    if (error) {
      notify(this.t(error.message));
    } else {
      message_.json_data.picture = files.fileInfo.location;
      await this.props.onSendMessage(message_);
      const { message } = this.props;
      if (message.error) {
        notify(this.t(message.error.message));
      } else {
        this.props.onPictureClean();
      }
    }
    this.scrollToBottom();
    form.reset()
  }

  deleteMessage = () => {

  }

  render() {
    const { root, chatWith, image_loading, chat, seenIndex, loadingMessages, owner, pickerOpen, preview, loading, root_id, deleteMode, transaction } = this.state;
    return (
      <LayoutSmall
        main={{ className: "" }}
        header={{
          className: "absolute top-0 w-auto z-20 !bg-transparent flex justify-between p-3",
          left: { icon: 'arrow_left', action: () => { history.push(config.ROUTES.MESSAGES) } },
        }}
        container={{ className: "px-0 relative" }}
      >
        <AutoQuery getData={this.getChat} />
        <main className="w-full h-screen bg-primary flex flex-col">
          <section className="text-primary-content text-center px-3 py-8 items-stretch">
            {(!loading && !image_loading) && <UserMessageHeader professional={chatWith} />}
          </section>
          {/* LOADER */}
          {(!loading && !image_loading) || <div className='flex absolute h-screen top-0 w-full bg-base-200 z-10'><Loader /></div>}
          <div className='flex flex-col bg-base-200 pt-5 px-2 grow rounded-t-3xl w-full'>
            <ToastContainer />

            {/* CHAT */}
            <div id='chat' className={`chat-container overflow-scroll overflow-x-hidden scrollbar rounded-t-3xl`}>
              {/* DATE and LINK TO SEE PURCHASE */}
              <div className='flex justify-between px-5 fixed bg-base-200 w-full left-0  pb-3 z-10'>
                {root?.related_to && transaction?.type === 'purchase' && <Link to={{ pathname: config.ROUTES.PURCHASES.DETAIL.replace(':id', root.related_to), state: { root_id } }} className='text-primary border border-primary px-3 py-1 rounded-full font-semibold text-xs'>VER PEDIDO</Link>}

                <span className='px-3 py-1 rounded-full  text-xs bg-gray-100 text-gray-600'>{root?.created_at.slice(0, 10)}</span>
              </div>
              {/* PREVIEW */}
              {preview &&
                <div className='flex pt-10 bg-white justify-center overflow-hidden items-center w-full h-full'>
                  <p className='absolute top-3 left-10'>Preview</p>
                  <button onClick={() => this.props.onPictureClean()}><Icon className="w-5 h-5 absolute top-3 left-3" name='close' /></button>
                  <div className='w-36'><img src={preview.src} alt="" /></div>
                </div>}

              {transaction?.json_data?.payment_id && <p>Pagado</p>}
              {/* MESSAGES CONTAINER */}
              <div className='pt-10 text-white'>
                {!preview && chat.map((message, i, array) => {
                  const date = new Date(message['created_at'])
                  // const month = capitalize(date.toLocaleDateString(undefined, { month: 'long' }).substring(0, 3))
                  // const day = date.toLocaleDateString(undefined, { day: 'numeric' })
                  const time = date.toLocaleTimeString(undefined, { hour: 'numeric', minute: 'numeric' })
                  if (message.body == "__PEDIDO__") {
                    return (
                      <div key={message.id || 'load' + i} className='bg-gray-600 rounded-2xl mx-2 px-4 py-3 max-w-sm mb-4'>
                        <h3 className='font-bold'>Tu pedido fue enviado</h3>
                        <p>{"Esperando cotización de la farmacia."}</p>
                      </div>
                    )
                  }
                  if (message.body == "__COBRO__" || message.body == "__COBRO_PROF__") {
                    if (!transaction?.json_data?.transaction_amount) {
                      window.location.reload();
                    }
                    return (
                      <div key={message.id || 'load' + i} className='bg-gray-600 rounded-2xl mx-2 px-4 py-3 max-w-sm mb-4'>
                        <h3 className=''>El total de tu pedido es de <span className='font-bold'>${`${transaction?.json_data?.transaction_amount}`}</span></h3>
                        {transaction?.json_data?.init_point && !transaction?.json_data?.payment_id && <Link
                          className="btn-primary inline-block mb-1 mt-2 border border-primary px-3 py-1 rounded-full font-semibold" // bg-[#00b0ef] fixme: por que tenia este color de fondo?
                          title={"Pagar en Mercado Pago"}
                          onClick={async () => {
                            window.open(transaction?.json_data?.init_point, "_self")
                          }}
                        >Pagar en Mercado Pago</Link>}
                        {transaction?.json_data?.payment_id && <p className='text-success font-semibold'>El pago se acreditó correctamente</p>}
                      </div>
                    )
                  }
                  // if (message.body == "__COBRO_PROF__") {
                  //   return (
                  //     <div key={message.id || 'load' + i} className='bg-gray-600 rounded-2xl mx-2 px-4 py-3 max-w-sm mb-4'>
                  //       <h3 className=''>El total de tu pedido es de <span className='font-bold'>${`${transaction?.json_data?.transaction_amount}`}</span></h3>
                  //       {transaction?.json_data?.init_point && !transaction?.json_data?.payment_id && <Link
                  //         className="btn-primary inline-block mb-1 mt-2 border border-primary px-3 py-1 rounded-full font-semibold" // bg-[#00b0ef]
                  //         title={"Pagar en Mercado Pago"}
                  //         onClick={async () => {
                  //           window.open(transaction?.json_data?.init_point, "_self")
                  //         }}
                  //       >Pagar en Mercado Pago</Link>}
                  //       {transaction?.json_data?.payment_id && <p className='text-success font-semibold'>El pago se acreditó correctamente</p>}
                  //     </div>
                  //   )
                  // }

                  return (
                    <div key={message.id || 'load' + i} id={`message${i}`} className={`mb-4 chat ${alignment(message, owner)}`}>
                      {message?.json_data?.prescription ?
                        <PrescriptionElement
                          prescription={message.json_data.prescription}
                          onClick={() => history.push({ pathname: config.ROUTES.PRESCRIPTION.replace(':id', message.json_data.prescription.id), state: { root_id: root?.id } })}
                        />
                        :
                        <>
                          <div className={`chat-bubble max-w-lg text-justify ${style(message, owner, array, i)}`}>
                            {message?.json_data?.picture && !message?.json_data?.deleted_for_all && <img className='image-message mb-2' src={message.json_data.picture} alt="" />}
                            {message.body}
                          </div>
                          <div className='chat-footer opacity-50 text-black'>
                            {message.loading ?
                              <Loader containerClassName="px-1 py-1 ml-2 relative" spinnerClassName="text-secondary h-3 w-3" />
                              :
                              (deleteMode ? <button onClick={() => this.deleteMessage(i, message)}><Icon className="h-3 w-3" name="trash" /></button> : time)}
                          </div>
                        </>
                      }
                      {seen(seenIndex, array, owner, i) && <span className='text-xs px-4 py-1 text-gray-400'>{this.t('Seen')}</span>}
                    </div>
                  )
                })}
              </div>
              {root?.json_data?.paused ? <p className='text-center p-3 text-gray-400'>{this.t('Conversación pausada')}</p> : null}
            </div>

            {/* MESSAGE INPUT */}
            {!root?.json_data?.paused && <Form
              initialValues={{}}
              onSubmit={preview ? this.uploadImage : this.onSubmit}
              mutators={{
                insertEmoji: (args, state, utils) => {
                  utils.changeValue(state, 'body', () => (args[1] || '') + args[0].emoji)
                },
              }}
            >
              {({ handleSubmit, form, values }) => {
                return (
                  <FormLayout form={form} onSubmit={handleSubmit}>
                    {<div className='absolute left-0 bottom-0 w-full'>
                      <div className='input flex items-center m-1'>
                        <div className='border-r pr-2'>
                          <Field
                            name="picture"
                            component={AttachImage}
                            icon='photograph'
                            placeholder={this.t('Send an image')}
                            inputOnChange={this.previewImage}
                            readOnly={loadingMessages || loading || root?.json_data?.paused}
                            noError={true}
                          />
                        </div>
                        {/* <div className='border-r px-2'>
                        <button type='button' className={`${loadingMessages || loading || root?.json_data?.paused ? 'disabled' : null} flex`}><Icon onClick={() => {
                          setPickerOpen(!pickerOpen)
                          focusInput()
                        }} className="h-4 w-4" name={pickerOpen ? 'close' : "emoji_face"} /></button>
                      </div> */}
                        <Field
                          name="body"
                          component={TextWithIconButtonInput}
                          placeholder={this.t('Send a message')}
                          readOnly={loadingMessages || loading || root?.json_data?.paused}
                          icon={'paper_airplane'}
                          inputClassName={'pl-2 ml-2'}
                        />
                      </div>
                      {<div className={!pickerOpen ? 'hidden' : null}>
                        <Picker
                          className='w-full'
                          searchPlaceholder='Search emojis'
                          pickerStyle={{ width: '100%', height: '40vh' }}
                          onEmojiClick={(e, emoji) => {
                            form.mutators.insertEmoji(emoji, values.body)
                            focusInput()
                          }}
                          disableAutoFocus
                        />
                      </div>}
                    </div>}
                  </FormLayout>
                );
              }}
            </Form>}
          </div>
        </main>
      </LayoutSmall>
    );
  }
}


const mapStateToProps = state => {
  return {
    auth: state.users.auth,
    user: state.users.auth.user,
    message: state.messages.current,
    messages: state.messages.list,
    internals: state.internals,
    transaction: state.purchases.current,
    files: state.files,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onGetPurchase: (id) => dispatch(purchasesActions.get(id)),
    onGetAllMessages: (params) => dispatch(messagesActions.getAll(params)),
    onGetMessage: (id) => dispatch(messagesActions.get(id)),
    onSendMessage: (params) => dispatch(messagesActions.saveOrUpdate(params)),
    onSendMail: (params) => dispatch(internalsActions.sendMail(params)),
    onPictureUpload: (params) => dispatch(filesActions.upload(params)),
    onPictureClean: () => dispatch(filesActions.clean()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(ChatClass));